var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPoint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 13.1433C6.25 8.24427 10.155 4.25 15 4.25C19.845 4.25 23.75 8.24427 23.75 13.1433C23.75 15.5084 23.076 18.0479 21.8844 20.2419C20.6944 22.4331 18.9556 24.3372 16.7805 25.3539C15.6506 25.882 14.3494 25.882 13.2195 25.3539C11.0444 24.3372 9.30562 22.4331 8.11556 20.2419C6.92403 18.0479 6.25 15.5084 6.25 13.1433ZM15 5.75C11.0084 5.75 7.75 9.04748 7.75 13.1433C7.75 15.2404 8.35263 17.5354 9.4337 19.526C10.5162 21.5192 12.046 23.1496 13.8546 23.995C14.5821 24.335 15.4179 24.335 16.1454 23.995C17.954 23.1496 19.4838 21.5192 20.5663 19.526C21.6474 17.5354 22.25 15.2404 22.25 13.1433C22.25 9.04748 18.9916 5.75 15 5.75ZM15 10.75C13.7574 10.75 12.75 11.7574 12.75 13C12.75 14.2426 13.7574 15.25 15 15.25C16.2426 15.25 17.25 14.2426 17.25 13C17.25 11.7574 16.2426 10.75 15 10.75ZM11.25 13C11.25 10.9289 12.9289 9.25 15 9.25C17.0711 9.25 18.75 10.9289 18.75 13C18.75 15.0711 17.0711 16.75 15 16.75C12.9289 16.75 11.25 15.0711 11.25 13Z",
    fill: "#F7BD01"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoint);
export default __webpack_public_path__ + "static/media/point.8c453455d21614b03f46558ce1e56139.svg";
export { ForwardRef as ReactComponent };